import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './style.module.scss';

interface Props {
  onClick: () => void;
}

const CreateUserAlert = ({ onClick }: Props) => {
  const intl = useIntl();
  return (
    <div className={css.wrapper}>
      <p className={css.paragraph}>
        {intl.formatMessage({ id: 'createUserAlert.pleaseRegister' })}
      </p>
      <p className={css.paragraph}>
        <FormattedMessage
          id="createUserAlert.pleaseLogin"
          values={{
            login: (
              <a onClick={onClick} className={css.link}>
                {intl.formatMessage({ id: 'createUserAlert.here' })}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default CreateUserAlert;
